const loadCheckoutPage = () => import('./components/CheckoutPage')

export const preloadCheckoutPage = () => {
  void loadCheckoutPage()
}

export default loadCheckoutPage
